.trophyHistoryRow {
    border-bottom: 1px solid var(--mantine-color-dark-5);
    padding: 0.3rem;
}
